import { buildPalette, buildAccent } from "./goldenPalettes";
import {
  rotateColorBy,
  normalizeRGB,
  hexToRgba,
  rgbToHex,
  arrayToPalette,
} from "./color.utils";

const palette = (color: string) => {
  const rgb = normalizeRGB(hexToRgba(color));
  const base = buildPalette(rgb);
  const accent = buildAccent(rgb);
  return arrayToPalette(base.concat(accent).map((rgbColor: any) => rgbToHex(rgbColor)));
};

const complementary = (color: string) => rotateColorBy(color, 180);

const firstAnalogous = (color: string) => rotateColorBy(color, -30);

const secondAnalogous = (color: string) => rotateColorBy(color, 30);

const firstTriadic = (color: string) => rotateColorBy(color, 60);

const secondTriadic = (color: string) => rotateColorBy(color, 120);

export default function generateColorPalette(color: string) {
  return {
    palette: palette(color),
    complementary: complementary(color),
    firstAnalogousL: firstAnalogous(color),
    secondAnalogous: secondAnalogous(color),
    firstTriadic: firstTriadic(color),
    secondTriadic: secondTriadic(color),
  };
}
